import VueSelect from 'vue-select'
import SettingsDropdown from './SettingsDropdown'
import Tooltip from './Tooltip'
import InvalidFeedback from './validator/InvalidFeedback'
import CheckoutButton from "./CheckoutButton"
import Tutorial from './Tutorials.vue'
import FloatingSettings from './FloatingSettings'
import SelectInfiniteScroll from './SelectInfiniteScroll'

export default (Vue, options) => {
    Vue.component('protokol-settings-dropdown', SettingsDropdown)
    Vue.component('protokol-tooltip', Tooltip)
    Vue.component('protokol-invalid-feedback', InvalidFeedback)
    Vue.component('protokol-input-select', VueSelect)
    Vue.component('protokol-checkout-button', CheckoutButton)
    Vue.component('protokol-tutorial', Tutorial)
    Vue.component('protokol-floating-settings', FloatingSettings)
    Vue.component('protokol-infinite-scroll', SelectInfiniteScroll)
}

export {
    SettingsDropdown,
    Tooltip,
    InvalidFeedback,
    VueSelect,
    Tutorial,
    FloatingSettings
}